const BACKEND_URL = 'https://wishlist-backend-production-d820.up.railway.app';
const STOREFRONT_TOKEN = 'eb08250ffcecb0dbb7d0f9f16daa5d2f';

function t(key, replacements = {}) {
  const keys = key.split('.');
  let value = window.theme?.strings;
  for (const k of keys) value = value?.[k];
  if (typeof value !== 'string') return null;
  return Object.entries(replacements).reduce((str, [k, v]) => str.replace(`[${k}]`, v), value);
}

function getSessionId() {
  let id = localStorage.getItem('wishlist_session_id');
  if (!id) {
    id = 'sess_' + Math.random().toString(36).substr(2, 16);
    localStorage.setItem('wishlist_session_id', id);
  }
  return id;
}

async function fetchWishlist() {
  const res = await fetch(`${BACKEND_URL}/wishlist/${getSessionId()}`);
  const data = await res.json();
  const ids = data.map(i => i.product_id);
  localStorage.setItem('wishlist_ids', JSON.stringify(ids));
  localStorage.setItem('wishlist_count', data.length);
  return data;
}

async function toggleWishlist(productId, productTitle, productImage, productUrl, productHandle, productInventory) {
  const sessionId = getSessionId();
  const isWishlistPage = !!document.getElementById('wishlist-page-container');

  const cachedIds = JSON.parse(localStorage.getItem('wishlist_ids') || '[]');
  const existsInCache = cachedIds.includes(productId);
  if (existsInCache) {
    localStorage.setItem('wishlist_ids', JSON.stringify(cachedIds.filter(id => id !== productId)));
  } else {
    localStorage.setItem('wishlist_ids', JSON.stringify([...cachedIds, productId]));
  }

  document.querySelectorAll(`[data-wishlist-btn][data-product-id="${productId}"]`).forEach(btn => {
    const isActive = btn.classList.toggle('wishlist-active');
    const label = isActive
      ? (t('wishlist.removeLabel') || 'Poista toivelistalta')
      : (t('wishlist.addLabel') || 'Lisää toivelistalle');
    btn.setAttribute('aria-label', label);
    const span = btn.querySelector('.wishlist-btn-text');
    if (span) span.textContent = label;
  });

  if (isWishlistPage && existsInCache) {
    const card = document.querySelector(`[data-wishlist-item-id="${productId}"]`);
    if (card) card.remove();
    const container = document.getElementById('wishlist-page-container');
    if (container && container.children.length === 0) {
      container.innerHTML = `<p>${t('wishlist.empty') || 'Toivelistasi on tyhjä.'}</p>`;
    }
  }

  if (existsInCache) {
    await fetch(`${BACKEND_URL}/wishlist/${sessionId}/${productId}`, { method: 'DELETE' });
  } else {
    await fetch(`${BACKEND_URL}/wishlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: sessionId,
        product_id: productId,
        product_title: productTitle,
        product_image: productImage,
        product_url: productUrl,
        product_handle: productHandle,
        product_inventory: productInventory
      })
    });
  }

  updateHeaderCount(true);
}

async function updateAllHearts() {
  const ids = JSON.parse(localStorage.getItem('wishlist_ids') || '[]');
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    const isActive = ids.includes(btn.dataset.productId);
    btn.classList.toggle('wishlist-active', isActive);
    const label = isActive
      ? (t('wishlist.removeLabel') || 'Poista toivelistalta')
      : (t('wishlist.addLabel') || 'Lisää toivelistalle');
    btn.setAttribute('aria-label', label);
    const span = btn.querySelector('.wishlist-btn-text');
    if (span) span.textContent = label;
  });
  fetchWishlist().then(wishlist => {
    const freshIds = wishlist.map(i => i.product_id);
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const isActive = freshIds.includes(btn.dataset.productId);
      btn.classList.toggle('wishlist-active', isActive);
      const label = isActive
        ? (t('wishlist.removeLabel') || 'Poista toivelistalta')
        : (t('wishlist.addLabel') || 'Lisää toivelistalle');
      btn.setAttribute('aria-label', label);
      const span = btn.querySelector('.wishlist-btn-text');
      if (span) span.textContent = label;
    });
  });
}

async function updateHeaderCount(fromBackend = false) {
  const bubble = document.getElementById('wishlist-icon-bubble');
  const count = document.getElementById('wishlist-count');
  if (!bubble || !count) return;

  if (!fromBackend) {
    const cached = parseInt(localStorage.getItem('wishlist_count') || '0');
    count.textContent = cached;
    bubble.style.display = cached > 0 ? 'block' : 'none';
  } else {
    const wishlist = await fetchWishlist();
    count.textContent = wishlist.length;
    bubble.style.display = wishlist.length > 0 ? 'block' : 'none';
  }
}

async function fetchProductStorefront(handle) {
  try {
    const res = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: `{
        product(handle: "${handle}") {
          id title handle vendor
          featuredImage { url }
          variants(first: 100) {
            edges { node {
              id title sku availableForSale currentlyNotInStock quantityAvailable
              price { amount currencyCode }
            }}
          }
        }
      }`})
    });
    const data = await res.json();
    const p = data?.data?.product;
    if (!p) return null;
    const variants = p.variants.edges.map(e => e.node);
    return {
      id: p.id.split('/').pop(),
      title: p.title,
      handle: p.handle,
      vendor: p.vendor,
      featured_image: p.featuredImage?.url,
      variants: variants.map(v => ({
        id: v.id.split('/').pop(),
        title: v.title,
        sku: v.sku,
        available: v.availableForSale,
        currentlyNotInStock: v.currentlyNotInStock,
        quantityAvailable: v.quantityAvailable,
        priceAmount: parseFloat(v.price.amount)
      }))
    };
  } catch {
    return null;
  }
}

async function renderWishlistPage() {
  const container = document.getElementById('wishlist-page-container');
  if (!container) return;

  // Lataa CSS-tiedostot
  ['product.css', 'product-page.css', 'quick-add.css'].forEach(filename => {
    if (!document.querySelector(`link[href*="${filename}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `//4fiyi6-rs.myshopify.com/cdn/shop/t/25/assets/${filename}`;
      document.head.appendChild(link);
    }
  });

  // Lataa quick-add.js ja variant-picker.js ENNEN tuotekorttien renderöintiä
  await Promise.all([
    !customElements.get('quick-add-drawer') && new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = '//4fiyi6-rs.myshopify.com/cdn/shop/t/25/assets/quick-add.js';
      s.onload = resolve;
      s.onerror = reject;
      document.body.appendChild(s);
    }),
    !customElements.get('variant-picker') && new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = '//4fiyi6-rs.myshopify.com/cdn/shop/t/25/assets/variant-picker.js';
      s.onload = resolve;
      s.onerror = reject;
      document.body.appendChild(s);
    })
  ].filter(Boolean));

  await Promise.all([
    customElements.whenDefined('quick-add-drawer'),
    customElements.whenDefined('variant-picker')
  ]);

  const wishlist = await fetchWishlist();
  if (wishlist.length === 0) {
    container.innerHTML = `<p>${t('wishlist.empty') || 'Toivelistasi on tyhjä.'}</p>`;
    return;
  }

  const productData = await Promise.all(
    wishlist.map(item => {
      const handle = item.product_handle || item.product_url?.split('/products/')[1]?.split('?')[0] || null;
      return handle ? fetchProductStorefront(handle) : Promise.resolve(null);
    })
  );

  container.className = 'grid mb-8 md:mb-12 grid-cols-2 sm:grid-cols-3 gap-x-theme gap-y-16';
  container.setAttribute('role', 'list');

  container.innerHTML = wishlist.map((item, index) => {
    const p = productData[index];
    if (!p) return '';

    const variant = p.variants[0];
    const price = variant.priceAmount.toLocaleString('fi-FI', { minimumFractionDigits: 2 }) + ' €';
    const image = p.featured_image || item.product_image;

    const sku = variant.sku
      ? `<div class="product-card__sku" style="font-size:0.85em;color:#6b7280;margin-bottom:0.5rem;">${t('wishlist.itemNumber') || 'Tuotenumero'}: ${variant.sku}</div>`
      : '';

    const vendor = p.vendor && p.vendor !== '-' && p.vendor !== '.'
      ? `<p class="card__vendor mb-0 text-sm text-theme-light">${p.vendor}</p>`
      : '';

    const anyAvailable = p.variants.some(v => v.available);
    const anyBackorder = p.variants.some(v => v.currentlyNotInStock);
    const totalQty = p.variants.reduce((sum, v) => sum + (v.quantityAvailable || 0), 0);
    const qtyText = (t('wishlist.inStockQty') || '({quantity} kpl)').replace('{quantity}', totalQty);

    let inventoryHtml = '';
    if (anyBackorder) {
      inventoryHtml = `<div class="pt-5 text-xs product-inventory__status" data-inventory-level="backordered">${t('backordered') || 'Tilaustuote'}</div>`;
    } else if (anyAvailable) {
      inventoryHtml = `<div class="pt-5 text-xs product-inventory__status" data-inventory-level="in_stock">${t('inStock') || 'Varastossa'} ${qtyText}</div>`;
    } else {
      inventoryHtml = `<div class="pt-5 text-xs product-inventory__status" data-inventory-level="out_of_stock">${t('noStock') || 'Tilapäisesti loppu'}</div>`;
    }

    const hasOnlyDefault = p.variants.length === 1 && p.variants[0].title === 'Default Title';
    const addToCartLabel = t('wishlist.addToCart') || 'Lisää koriin';
    const optionsLabel = t('wishlist.options') || 'Vaihtoehdot';

    const productUrl = (Shopify?.locale && Shopify.locale !== 'fi')
      ? `/${Shopify.locale}/products/${p.handle}`
      : `/products/${p.handle}`;

    const quickAdd = hasOnlyDefault
      ? `<button class="btn btn--primary w-full js-wishlist-atc" data-variant-id="${variant.id}" data-product-id="${p.id}">${addToCartLabel}</button>`
      : `<button type="button" class="btn btn--primary w-full js-quick-add" aria-haspopup="dialog" data-product-url="${productUrl}" data-product-default-variant="false">
          <span class="quick-add-btn-icon block pointer-events-none"><span class="visually-hidden">${optionsLabel}</span></span>
          <span class="quick-add-btn-text block pointer-events-none">${optionsLabel}</span>
        </button>`;

    return `
      <li class="js-pagination-result" style="list-style:none;" data-wishlist-item-id="${p.id}">
        <product-card class="card card--product h-full card--no-lines relative flex" data-product-id="${p.id}">
          <div class="card__media relative">
            <a href="/products/${p.handle}" class="media block relative js-prod-link" style="padding-top:100%;" tabindex="-1">
              <img src="${image}" alt="${p.title}" class="img-fit card__main-image" loading="lazy">
            </a>
            <button
              class="wishlist-btn wishlist-active"
              data-wishlist-btn
              data-product-id="${p.id}"
              data-product-title="${p.title}"
              data-product-image="${image}"
              data-product-url="/products/${p.handle}"
              data-product-handle="${p.handle}"
              data-product-inventory="${item.product_inventory || ''}"
              aria-label="${t('wishlist.removeLabel') || 'Poista toivelistalta'}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" class="wishlist-icon-svg">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="#e63946" stroke="none" class="wishlist-icon-fill"/>
              </svg>
            </button>
          </div>
          <div class="card__info-container flex flex-col flex-auto relative">
            <div class="card__info w-full">
              <div class="card__info-inner flex flex-col h-full w-full">
                ${vendor}
                <p class="card__title font-bold mt-0 mb-5" style="position:relative;z-index:1;">
                  <a href="/products/${p.handle}" class="card-link text-current js-prod-link" style="position:relative;z-index:1;">${p.title}</a>
                </p>
                ${inventoryHtml}
                ${sku}
                <div class="flex grow items-end">
                  <div class="price price--bottom">
                    <div class="price__default">
                      <span class="price__current"><span class="js-value">${price}</span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below w-full">
              <div class="no-js-hidden w-full">${quickAdd}</div>
            </div>
          </div>
        </product-card>
      </li>
    `;
  }).join('');

  // Lisää koriin -napit (yksittäinen variantti)
  container.querySelectorAll('.js-wishlist-atc').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (btn.disabled) return;
      const variantId = btn.dataset.variantId;
      btn.textContent = t('wishlist.adding') || 'Lisätään...';
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });
        btn.textContent = t('wishlist.added') || 'Lisätty! ✓';
        setTimeout(() => {
          btn.textContent = t('wishlist.addToCart') || 'Lisää koriin';
          btn.disabled = false;
        }, 2000);
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      } catch {
        btn.textContent = t('wishlist.error') || 'Virhe';
        btn.disabled = false;
      }
    });
  });

  // Tyhjennä toivelista -painike
  const existingClearBtn = document.getElementById('clear-wishlist-button-wrapper');
  if (existingClearBtn) existingClearBtn.remove();

  if (wishlist.length > 0) {
    const clearWrapper = document.createElement('div');
    clearWrapper.id = 'clear-wishlist-button-wrapper';
    clearWrapper.className = 'mt-6 mb-8';
    clearWrapper.innerHTML = `
      <style>
        .btn--clear-wishlist {
          border: var(--btn-border-width) solid #dc2626 !important;
          outline-color: #dc2626 !important;
          outline-offset: 3px;
          background: #b91c1c linear-gradient(104deg, #b91c1c 60%, #dc2626 60%, #dc2626 100%) no-repeat 100% 100% !important;
          background-size: 300% 100% !important;
          color: white !important;
          transition: opacity 0.6s ease, color 0.6s ease, background-position 0.4s ease-out !important;
          margin-bottom: 15px;
          margin-top: -8px;
        }
        @media (hover: hover) and (pointer: fine) {
          .btn--clear-wishlist:not([disabled]):hover {
            background-position: 0 100% !important;
          }
        }
      </style>
      <button type="button" class="btn btn--clear-wishlist" id="clear-wishlist-btn">
        ${t('wishlist.clearAll') || 'Tyhjennä toivelista'}
      </button>
    `;

    container.parentElement.insertBefore(clearWrapper, container);

    document.getElementById('clear-wishlist-btn').addEventListener('click', async () => {
      const confirmMsg = t('wishlist.clearConfirm') || 'Haluatko varmasti tyhjentää koko toivelistan?';
      if (!confirm(confirmMsg)) return;

      const sessionId = getSessionId();
      await fetch(`${BACKEND_URL}/wishlist/${sessionId}`, { method: 'DELETE' });

      localStorage.setItem('wishlist_ids', '[]');
      localStorage.setItem('wishlist_count', '0');

      container.innerHTML = `<p>${t('wishlist.empty') || 'Toivelistasi on tyhjä.'}</p>`;
      clearWrapper.remove();

      updateHeaderCount(false);
      updateAllHearts();
    });
  }
} // renderWishlistPage sulkeva }

document.addEventListener('DOMContentLoaded', async () => {
  const bubble = document.getElementById('wishlist-icon-bubble');
  const count = document.getElementById('wishlist-count');
  const cached = parseInt(localStorage.getItem('wishlist_count') || '0');
  if (bubble && count && cached > 0) {
    count.textContent = cached;
    bubble.style.display = 'block';
  }

  updateAllHearts();
  updateHeaderCount(true);

  await renderWishlistPage();

  // Globaali wishlist-klikki
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    if (e.target.closest('.js-wishlist-atc') || e.target.closest('.js-quick-add')) return;
    e.preventDefault();
    toggleWishlist(
      btn.dataset.productId,
      btn.dataset.productTitle,
      btn.dataset.productImage,
      btn.dataset.productUrl,
      btn.dataset.productHandle,
      btn.dataset.productInventory
    );
  });

  // Varianttimuutos drawerissa – päivitä SKU ja hinta
  document.addEventListener('on:variant:change', e => {
    const drawer = document.querySelector('quick-add-drawer');
    if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;
    const variant = e.detail?.variant;
    if (!variant) return;

    const hiddenInput = drawer.querySelector('input[name="id"]');
    if (hiddenInput) hiddenInput.value = variant.id;

    const addBtn = drawer.querySelector('button[name="add"]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? (addBtn.dataset.addToCartText || t('wishlist.addToCart') || 'Lisää koriin')
        : (t('noStock') || 'Ei varastossa');
    }

    const skuEl = drawer.querySelector('[data-dynamic-variant-content="quickadd-sku"]');
    if (skuEl) {
      if (variant.sku) {
        skuEl.textContent = `Tuotekoodi: ${variant.sku}`;
        skuEl.hidden = false;
      } else {
        skuEl.hidden = true;
      }
    }

    const priceEl = drawer.querySelector('[data-dynamic-variant-content="quickadd-price-price"] .price__current .js-value, [data-dynamic-variant-content="quickadd-price-price"] .price__current');
    if (priceEl && variant.price) {
      const priceFormatted = (variant.price / 100).toLocaleString('fi-FI', { minimumFractionDigits: 2 }) + ' €';
      priceEl.textContent = priceFormatted;
    }
  });
});
